export const  POSTFREELACER = "POSTFREELACER";
export const POSTFREELACERSUCCESS = "POSTFREELACERSUCCESS";
export const POSTFREELACERFAILURE = "POSTFREELACERFAILURE";

export const  POSTRECUITER = "POSTRECUITER";
export const POSTRECUITER_SUCCESS = "POSTRECUITER_SUCCESS";
export const POSTRECUITERFAILURE = "POSTRECUITERFAILURE";